import { Profile } from '../../components/font-end/Profile/Profile';
import { Menubar } from '../../components/font-end/MasterLayout/Menubar';
import { AnouncementShow } from '../../components/font-end/Anouncement/AnouncementShow';
import { useUser } from '../../context/UserContext';

export const AnouncementDetail = (props: any) => {
    const { isLoading } = useUser();
  
    if (isLoading) {
      return (
        <div className="loading-pages text-center" style={{ backgroundColor: '#f0f0f0' }}>
          <div className="layout-loading">
            <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
          </div>
        </div>
      );
    }
  return (
    <>
      <Profile/>
      <AnouncementShow />``
      <Menubar />
    </>
  );
};
